import { render, staticRenderFns } from "./FurnitureList.vue?vue&type=template&id=e25ee95c"
import script from "./FurnitureList.vue?vue&type=script&lang=js"
export * from "./FurnitureList.vue?vue&type=script&lang=js"
import style0 from "./FurnitureList.vue?vue&type=style&index=0&id=e25ee95c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports